export default __webpack_public_path__ + "images/SG.facec06.png";